// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA4rY-aYZax7fKJgxtOr3lpaKLSy-30YNQ",
  authDomain: "weekplanner-it.firebaseapp.com",
  projectId: "weekplanner-it",
  storageBucket: "weekplanner-it.appspot.com",
  messagingSenderId: "414751904541",
  appId: "1:414751904541:web:70e3de1ac86770df8e87f4",
  measurementId: "G-25W7112LD0",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const firestore = getFirestore(app);
export default app;
